define('home/templates/channelGroupCard',['handlebars', 'handlebars.partials', 'core/extensions/handlebars.helpers'], function(Handlebars) {

return Handlebars.template({"1":function(container,depth0,helpers,partials,data) {
    return container.escapeExpression(container.lambda((depth0 != null ? depth0.exploreTab : depth0), depth0));
},"3":function(container,depth0,helpers,partials,data) {
    return "channels";
},"5":function(container,depth0,helpers,partials,data) {
    var stack1;

  return "<div class=\"channel-cover__logo spacing-bottom-narrow\">\n<img src=\""
    + container.escapeExpression(container.lambda(((stack1 = ((stack1 = (depth0 != null ? depth0.options : depth0)) != null ? stack1.titleLogo : stack1)) != null ? stack1.cache : stack1), depth0))
    + "\" class=\"img-responsive block__item\" />\n</div>\n";
},"compiler":[7,">= 4.0.0"],"main":function(container,depth0,helpers,partials,data) {
    var stack1, alias1=depth0 != null ? depth0 : {}, alias2=container.lambda, alias3=container.escapeExpression;

  return "<a href=\"/home/explore/"
    + ((stack1 = helpers["if"].call(alias1,(depth0 != null ? depth0.exploreTab : depth0),{"name":"if","hash":{},"fn":container.program(1, data, 0),"inverse":container.program(3, data, 0),"data":data})) != null ? stack1 : "")
    + "/"
    + alias3(alias2((depth0 != null ? depth0.slug : depth0), depth0))
    + "/\" alt=\""
    + alias3(alias2((depth0 != null ? depth0.name : depth0), depth0))
    + "\" class=\"explore__link link-gray-darker\">\n<div class=\"channel-tab__tile "
    + alias3(alias2((depth0 != null ? depth0.bannerColor : depth0), depth0))
    + " text-medium\">\n"
    + ((stack1 = helpers["if"].call(alias1,((stack1 = (depth0 != null ? depth0.options : depth0)) != null ? stack1.titleLogo : stack1),{"name":"if","hash":{},"fn":container.program(5, data, 0),"inverse":container.noop,"data":data})) != null ? stack1 : "")
    + "<strong>"
    + alias3(alias2((depth0 != null ? depth0.name : depth0), depth0))
    + "</strong>\n</div>\n</a>\n";
},"useData":true})

});
